import { EMAIL_TABLE_DATA, GSTINS, LOADER_STATUS, SELECTED_GSTIN, ACTIVE_TAB } from "./constants";

export const initialState = {
  loaderStatus: false,
  emailTableData:[],
  gstins:[],
  selectedGstins:[],
  activeTab: 1
};

/* eslint-disable default-case, no-param-reassign */
const emailConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case EMAIL_TABLE_DATA:
      return {
        ...state,
        emailTableData: action.emailTableData,
      };
      case GSTINS:
      return {
        ...state,
        gstins: action.gstins,
      };
      case SELECTED_GSTIN:
      return {
        ...state,
        selectedGstins: action.selectedGstins,
      };
      case ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };
    default:
      return state;
  }
};

export default emailConfigReducer;
